import { t } from '@lingui/core/macro';

/*
 * Enumeration of available user role groups
 */
export enum UserRoles {
  admin = 'admin',
  as9100_document = 'as9100_document',
  as9100_form = 'as9100_form',
  audit = 'audit',
  bom = 'bom',
  build = 'build',
  contracts = 'contracts',
  equipment = 'equipment',
  part = 'part',
  part_category = 'part_category',
  part_lock = 'part_lock',
  project = 'project',
  work_instruction = 'work_instruction',
  purchase_order = 'purchase_order',
  return_order = 'return_order',
  transfer_order = 'transfer_order',
  sales_order = 'sales_order',
  stock = 'stock',
  stock_location = 'stock_location'
}

/*
 * Enumeration of available user permissions within each role group
 */
export enum UserPermissions {
  view = 'view',
  add = 'add',
  change = 'change',
  delete = 'delete'
}

export function userRoleLabel(role: UserRoles): string {
  switch (role) {
    case UserRoles.admin:
      return t`Admin`;
    case UserRoles.as9100_document:
      return t`AS9100 Documents`;
    case UserRoles.as9100_form:
      return t`AS9100 Forms`;
    case UserRoles.audit:
      return t`Audit Log`;
    case UserRoles.build:
      return t`Build Orders`;
    case UserRoles.contracts:
      return t`Programs & Contracts`;
    case UserRoles.equipment:
      return t`Equipment`;
    case UserRoles.part:
      return t`Parts`;
    case UserRoles.part_category:
      return t`Part Categories`;
    case UserRoles.part_lock:
      return t`Part Locks`;
    case UserRoles.project:
      return t`Projects`;
    case UserRoles.work_instruction:
      return t`Work Instructions`;
    case UserRoles.purchase_order:
      return t`Purchase Orders`;
    case UserRoles.return_order:
      return t`Return Orders`;
    case UserRoles.transfer_order:
      return t`Transfer Orders`;
    case UserRoles.sales_order:
      return t`Sales Orders`;
    case UserRoles.stock:
      return t`Stock Items`;
    case UserRoles.stock_location:
      return t`Stock Location`;
    default:
      return role as string;
  }
}
